var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M23.9 6.9v6.3h6.5z" }),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M31.3 15v.1h-9.4V6.5H10.3v27h21V15zm-4.4 5.1L21 26.7c-.2.2-.5.4-.8.4-.2 0-.5-.1-.7-.2l-3.9-3.2c-.5-.4-.5-1.1-.2-1.6.4-.5 1.1-.6 1.6-.2l3.1 2.5 5.2-5.8c.4-.5 1.1-.5 1.6-.1.4.4.4 1.1 0 1.6z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Invoices.svg